// GENERATED FILE — DO NOT EDIT BY HAND.
//
// Source: apps/menu-api/supabase/migrations/*.sql (the `app_capability` seed).
// Regenerate: pnpm --filter @lemontaigu/platform gen:capabilities
// Verified in CI by check E9 (`--check`), so this file and the database
// catalogue cannot drift apart (ADR-0013 §4).

/** Every capability in the catalogue. Adding one is a MIGRATION, not an edit here. */
export const CAPABILITIES = {
  /** Lire les conversations et les messages des clients */
  CHAT_CONVERSATION_READ: 'chat.conversation.read',
  /** Répondre à un client dans la conversation */
  CHAT_CONVERSATION_REPLY: 'chat.conversation.reply',
  /** Modifier une conversation (prise en charge, clôture) */
  CHAT_CONVERSATION_WRITE: 'chat.conversation.write',
  /** Consulter les retours sur les réponses de l'IA */
  CHAT_FEEDBACK_READ: 'chat.feedback.read',
  /** Noter et corriger les réponses de l'IA */
  CHAT_FEEDBACK_WRITE: 'chat.feedback.write',
  /** Consulter les informations et consignes publiées */
  CHAT_NOTICE_READ: 'chat.notice.read',
  /** Gérer ses propres notifications push */
  CHAT_PUSH_MANAGE: 'chat.push.manage',
  /** Consulter les éléments déjà traités dans l'apprentissage */
  CHAT_REVIEW_READ: 'chat.review.read',
  /** Marquer un élément comme traité dans l'apprentissage */
  CHAT_REVIEW_WRITE: 'chat.review.write',
  /** Enregistrer une correction comptable (jamais modifiée : une erreur se corrige par une autre correction) */
  FIN_CORRECTION_RECORD: 'fin.correction.record',
  /** Savoir si le flux terminal et le miroir Vega sont à jour pour un jour donné (bandeau « flux en retard »), sans voir le détail */
  FIN_FEED_GATE: 'fin.feed.gate',
  /** Consulter le flux terminal Sextant — remises, transactions (carte masquée) et journal des relevés */
  FIN_FEED_READ: 'fin.feed.read',
  /** Voir les écarts du jour entre les paiements carte saisis dans Vega et les débits du terminal (réservation, montant, heures) — sans numéro de carte */
  FIN_FINDINGS_READ: 'fin.findings.read',
  /** Poster des écritures, les annuler par contre-passation, ouvrir et fermer les périodes */
  FIN_LEDGER_POST: 'fin.ledger.post',
  /** Consulter le grand livre — comptes, écritures, balance */
  FIN_LEDGER_READ: 'fin.ledger.read',
  /** Remettre à zéro le livre de preuve (jamais le livre de référence) */
  FIN_LEDGER_RESET: 'fin.ledger.reset',
  /** Modifier la liste des catégories de plats */
  MENU_COURSE_WRITE: 'menu.course.write',
  /** Composer les menus : plats et services */
  MENU_DISH_WRITE: 'menu.dish.write',
  /** Gérer les jours de service */
  MENU_SERVICE_WRITE: 'menu.service.write',
  /** Consulter l'historique des menus publiés */
  MENU_SNAPSHOT_READ: 'menu.snapshot.read',
  /** Accès opérateur complet (bos@) — administration de la plateforme */
  PLATFORM_ADMIN: 'platform.admin',
  /** Accès personnel : la banque d'accueil et les applications du personnel */
  PLATFORM_STAFF: 'platform.staff',
  /** Modifier la carte du bar et du restaurant : articles, prix, formules et choix proposés à la caisse de salle */
  PMS_CATALOGUE_WRITE: 'pms.catalogue.write',
  /** Passer au jour suivant (fin de journée de la réception) — refusé tant que l'établissement est en preuve */
  PMS_DAY_CLOSE: 'pms.day.close',
  /** Administration fiscale — consulter la caisse, ses clôtures et ses archives, vérifier l'intégrité, demander une archive */
  PMS_FISCAL_AUDIT: 'pms.fiscal.audit',
  /** Ouvrir et retirer l'accès d'un inspecteur de l'administration fiscale */
  PMS_FISCAL_INSPECTOR_MANAGE: 'pms.fiscal.inspector.manage',
  /** Voir les arrivées à venir et les départs à encaisser (chambres, nuits, montant dû) — sans noms ni détail des règlements */
  PMS_FRONTDESK_READ: 'pms.frontdesk.read',
  /** Consulter la fiche client */
  PMS_GUEST_READ: 'pms.guest.read',
  /** Créer et modifier une fiche client */
  PMS_GUEST_WRITE: 'pms.guest.write',
  /** Mettre à jour l'état ménage d'une chambre */
  PMS_HOUSEKEEPING_WRITE: 'pms.housekeeping.write',
  /** Émettre un avoir sur une facture */
  PMS_INVOICE_CREDIT: 'pms.invoice.credit',
  /** Consulter les factures, les avoirs et la chaîne fiscale */
  PMS_INVOICE_READ: 'pms.invoice.read',
  /** Émettre une facture à partir d'une note */
  PMS_INVOICE_WRITE: 'pms.invoice.write',
  /** Consulter le miroir Vega — réservations, annulations et effectifs tels que Vega les détient */
  PMS_MIRROR_READ: 'pms.mirror.read',
  /** Lire les besoins et allergies des personnes d'un séjour (données de santé, RGPD art. 9), pour les servir en sécurité — et les saisir avec le droit de modifier la réservation */
  PMS_NEEDS_READ: 'pms.needs.read',
  /** Consulter les alertes et les tâches techniques du PMS */
  PMS_OPS_READ: 'pms.ops.read',
  /** Acquitter une alerte du PMS */
  PMS_OPS_WRITE: 'pms.ops.write',
  /** Conserver des arrhes (arrhes perdues — sans facture ni TVA) */
  PMS_PAYMENT_FORFEIT: 'pms.payment.forfeit',
  /** Consulter le journal des encaissements et l'historique des transactions TPE */
  PMS_PAYMENT_READ: 'pms.payment.read',
  /** Encaisser (carte, espèces, chèque, ANCV, en attente) et faire acquitter la saisie TPE */
  PMS_PAYMENT_WRITE: 'pms.payment.write',
  /** Classer les écarts de la preuve PMS (M modèle, P correspondance, V Vega, R règle) */
  PMS_PROOF_CLASSIFY: 'pms.proof.classify',
  /** Consulter la preuve PMS — les journées passées contre Vega et leurs écarts */
  PMS_PROOF_READ: 'pms.proof.read',
  /** Reconstituer la preuve PMS depuis une date : historique Vega chargé, journées passées rejouées */
  PMS_PROOF_REPLAY: 'pms.proof.replay',
  /** Consulter les tarifs et les plans tarifaires */
  PMS_RATE_READ: 'pms.rate.read',
  /** Modifier les tarifs et les plans tarifaires */
  PMS_RATE_WRITE: 'pms.rate.write',
  /** Consulter les réservations, leur historique et les nuitées */
  PMS_RESERVATION_READ: 'pms.reservation.read',
  /** Créer et modifier une réservation, changer son statut, attribuer une chambre */
  PMS_RESERVATION_WRITE: 'pms.reservation.write',
  /** Consulter les chambres, catégories et blocages */
  PMS_ROOM_READ: 'pms.room.read',
  /** Modifier le paramétrage des chambres, catégories et blocages */
  PMS_ROOM_WRITE: 'pms.room.write',
  /** Gérer le seed depuis Vega — table de correspondance des catégories et exécution manuelle */
  PMS_SEED_MANAGE: 'pms.seed.manage',
  /** Caisse de salle : émettre un avoir de ticket et rembourser */
  PMS_TICKET_CREDIT: 'pms.ticket.credit',
  /** Caisse de salle : offrir une ligne (offert, motif obligatoire) */
  PMS_TICKET_OFFER: 'pms.ticket.offer',
  /** Caisse de salle : ouvrir une addition, y ajouter des lignes, encaisser un ticket */
  PMS_TICKET_SELL: 'pms.ticket.sell',
  /** Caisse de salle : annuler une ligne après impression de l'addition, abandonner une addition */
  PMS_TICKET_VOID_PRINTED: 'pms.ticket.void_printed',
  /** Remettre à zéro l'établissement de formation : effacer ses réservations, clients et journées de test */
  PMS_TRAINING_RESET: 'pms.training.reset',
  /** Voir toutes les taps carte du terminal, rapprochés et hors Vega compris (audit opérateur) */
  REC_TAPS_AUDIT: 'rec.taps.audit',
  /** Affecter le personnel aux activités (★) et retirer une présence */
  RH_BOARD_ASSIGN: 'rh.board.assign',
  /** Paramétrer les activités, qualifications et affectations types */
  RH_BOARD_MANAGE: 'rh.board.manage',
  /** Consulter le tableau de présence et le planning */
  RH_BOARD_READ: 'rh.board.read',
  /** Saisir la présence déclarée et la demande depuis la banque d'accueil */
  RH_BOARD_WRITE: 'rh.board.write',
  /** Lire le canal de messages du personnel */
  RH_CHANNEL_READ: 'rh.channel.read',
  /** Consulter les synthèses quotidiennes de l'équipe */
  RH_DIGEST_READ: 'rh.digest.read',
  /** Consulter les propositions de connaissances à valider */
  RH_KNOWLEDGE_READ: 'rh.knowledge.read',
  /** Valider ou écarter une proposition de connaissance */
  RH_KNOWLEDGE_WRITE: 'rh.knowledge.write',
  /** Gérer ses propres notifications push */
  RH_PUSH_MANAGE: 'rh.push.manage',
  /** Consulter le registre du personnel, y compris les données sensibles (RUP) */
  RH_REGISTER_READ: 'rh.register.read',
  /** Créer et modifier les fiches du personnel, contrats et codes PIN */
  RH_REGISTER_WRITE: 'rh.register.write',
  /** Consulter l'annuaire de l'équipe */
  RH_ROSTER_READ: 'rh.roster.read',
  /** Consulter tous les pointages */
  RH_TIMESHEET_READ: 'rh.timesheet.read',
  /** Voir qui est actuellement en poste (pointages ouverts) */
  RH_TIMESHEET_READ_OPEN: 'rh.timesheet.read_open',
  /** Corriger et saisir les pointages */
  RH_TIMESHEET_WRITE: 'rh.timesheet.write',
} as const;

/** The capability names, as a union — a typo is a compile error (ADR-0013 §4). */
export type Capability = (typeof CAPABILITIES)[keyof typeof CAPABILITIES];

/** Catalogue metadata, for an operator-facing admin screen. `description` is FR. */
export const CAPABILITY_CATALOGUE: readonly {
  name: Capability;
  context: string;
  description: string;
}[] = [
  { name: 'chat.conversation.read', context: 'chat', description: "Lire les conversations et les messages des clients" },
  { name: 'chat.conversation.reply', context: 'chat', description: "Répondre à un client dans la conversation" },
  { name: 'chat.conversation.write', context: 'chat', description: "Modifier une conversation (prise en charge, clôture)" },
  { name: 'chat.feedback.read', context: 'chat', description: "Consulter les retours sur les réponses de l'IA" },
  { name: 'chat.feedback.write', context: 'chat', description: "Noter et corriger les réponses de l'IA" },
  { name: 'chat.notice.read', context: 'chat', description: "Consulter les informations et consignes publiées" },
  { name: 'chat.push.manage', context: 'chat', description: "Gérer ses propres notifications push" },
  { name: 'chat.review.read', context: 'chat', description: "Consulter les éléments déjà traités dans l'apprentissage" },
  { name: 'chat.review.write', context: 'chat', description: "Marquer un élément comme traité dans l'apprentissage" },
  { name: 'fin.correction.record', context: 'fin', description: "Enregistrer une correction comptable (jamais modifiée : une erreur se corrige par une autre correction)" },
  { name: 'fin.feed.gate', context: 'fin', description: "Savoir si le flux terminal et le miroir Vega sont à jour pour un jour donné (bandeau « flux en retard »), sans voir le détail" },
  { name: 'fin.feed.read', context: 'fin', description: "Consulter le flux terminal Sextant — remises, transactions (carte masquée) et journal des relevés" },
  { name: 'fin.findings.read', context: 'fin', description: "Voir les écarts du jour entre les paiements carte saisis dans Vega et les débits du terminal (réservation, montant, heures) — sans numéro de carte" },
  { name: 'fin.ledger.post', context: 'fin', description: "Poster des écritures, les annuler par contre-passation, ouvrir et fermer les périodes" },
  { name: 'fin.ledger.read', context: 'fin', description: "Consulter le grand livre — comptes, écritures, balance" },
  { name: 'fin.ledger.reset', context: 'fin', description: "Remettre à zéro le livre de preuve (jamais le livre de référence)" },
  { name: 'menu.course.write', context: 'menu', description: "Modifier la liste des catégories de plats" },
  { name: 'menu.dish.write', context: 'menu', description: "Composer les menus : plats et services" },
  { name: 'menu.service.write', context: 'menu', description: "Gérer les jours de service" },
  { name: 'menu.snapshot.read', context: 'menu', description: "Consulter l'historique des menus publiés" },
  { name: 'platform.admin', context: 'platform', description: "Accès opérateur complet (bos@) — administration de la plateforme" },
  { name: 'platform.staff', context: 'platform', description: "Accès personnel : la banque d'accueil et les applications du personnel" },
  { name: 'pms.catalogue.write', context: 'pms', description: "Modifier la carte du bar et du restaurant : articles, prix, formules et choix proposés à la caisse de salle" },
  { name: 'pms.day.close', context: 'pms', description: "Passer au jour suivant (fin de journée de la réception) — refusé tant que l'établissement est en preuve" },
  { name: 'pms.fiscal.audit', context: 'pms', description: "Administration fiscale — consulter la caisse, ses clôtures et ses archives, vérifier l'intégrité, demander une archive" },
  { name: 'pms.fiscal.inspector.manage', context: 'pms', description: "Ouvrir et retirer l'accès d'un inspecteur de l'administration fiscale" },
  { name: 'pms.frontdesk.read', context: 'pms', description: "Voir les arrivées à venir et les départs à encaisser (chambres, nuits, montant dû) — sans noms ni détail des règlements" },
  { name: 'pms.guest.read', context: 'pms', description: "Consulter la fiche client" },
  { name: 'pms.guest.write', context: 'pms', description: "Créer et modifier une fiche client" },
  { name: 'pms.housekeeping.write', context: 'pms', description: "Mettre à jour l'état ménage d'une chambre" },
  { name: 'pms.invoice.credit', context: 'pms', description: "Émettre un avoir sur une facture" },
  { name: 'pms.invoice.read', context: 'pms', description: "Consulter les factures, les avoirs et la chaîne fiscale" },
  { name: 'pms.invoice.write', context: 'pms', description: "Émettre une facture à partir d'une note" },
  { name: 'pms.mirror.read', context: 'pms', description: "Consulter le miroir Vega — réservations, annulations et effectifs tels que Vega les détient" },
  { name: 'pms.needs.read', context: 'pms', description: "Lire les besoins et allergies des personnes d'un séjour (données de santé, RGPD art. 9), pour les servir en sécurité — et les saisir avec le droit de modifier la réservation" },
  { name: 'pms.ops.read', context: 'pms', description: "Consulter les alertes et les tâches techniques du PMS" },
  { name: 'pms.ops.write', context: 'pms', description: "Acquitter une alerte du PMS" },
  { name: 'pms.payment.forfeit', context: 'pms', description: "Conserver des arrhes (arrhes perdues — sans facture ni TVA)" },
  { name: 'pms.payment.read', context: 'pms', description: "Consulter le journal des encaissements et l'historique des transactions TPE" },
  { name: 'pms.payment.write', context: 'pms', description: "Encaisser (carte, espèces, chèque, ANCV, en attente) et faire acquitter la saisie TPE" },
  { name: 'pms.proof.classify', context: 'pms', description: "Classer les écarts de la preuve PMS (M modèle, P correspondance, V Vega, R règle)" },
  { name: 'pms.proof.read', context: 'pms', description: "Consulter la preuve PMS — les journées passées contre Vega et leurs écarts" },
  { name: 'pms.proof.replay', context: 'pms', description: "Reconstituer la preuve PMS depuis une date : historique Vega chargé, journées passées rejouées" },
  { name: 'pms.rate.read', context: 'pms', description: "Consulter les tarifs et les plans tarifaires" },
  { name: 'pms.rate.write', context: 'pms', description: "Modifier les tarifs et les plans tarifaires" },
  { name: 'pms.reservation.read', context: 'pms', description: "Consulter les réservations, leur historique et les nuitées" },
  { name: 'pms.reservation.write', context: 'pms', description: "Créer et modifier une réservation, changer son statut, attribuer une chambre" },
  { name: 'pms.room.read', context: 'pms', description: "Consulter les chambres, catégories et blocages" },
  { name: 'pms.room.write', context: 'pms', description: "Modifier le paramétrage des chambres, catégories et blocages" },
  { name: 'pms.seed.manage', context: 'pms', description: "Gérer le seed depuis Vega — table de correspondance des catégories et exécution manuelle" },
  { name: 'pms.ticket.credit', context: 'pms', description: "Caisse de salle : émettre un avoir de ticket et rembourser" },
  { name: 'pms.ticket.offer', context: 'pms', description: "Caisse de salle : offrir une ligne (offert, motif obligatoire)" },
  { name: 'pms.ticket.sell', context: 'pms', description: "Caisse de salle : ouvrir une addition, y ajouter des lignes, encaisser un ticket" },
  { name: 'pms.ticket.void_printed', context: 'pms', description: "Caisse de salle : annuler une ligne après impression de l'addition, abandonner une addition" },
  { name: 'pms.training.reset', context: 'pms', description: "Remettre à zéro l'établissement de formation : effacer ses réservations, clients et journées de test" },
  { name: 'rec.taps.audit', context: 'fin', description: "Voir toutes les taps carte du terminal, rapprochés et hors Vega compris (audit opérateur)" },
  { name: 'rh.board.assign', context: 'rh', description: "Affecter le personnel aux activités (★) et retirer une présence" },
  { name: 'rh.board.manage', context: 'rh', description: "Paramétrer les activités, qualifications et affectations types" },
  { name: 'rh.board.read', context: 'rh', description: "Consulter le tableau de présence et le planning" },
  { name: 'rh.board.write', context: 'rh', description: "Saisir la présence déclarée et la demande depuis la banque d'accueil" },
  { name: 'rh.channel.read', context: 'rh', description: "Lire le canal de messages du personnel" },
  { name: 'rh.digest.read', context: 'rh', description: "Consulter les synthèses quotidiennes de l'équipe" },
  { name: 'rh.knowledge.read', context: 'rh', description: "Consulter les propositions de connaissances à valider" },
  { name: 'rh.knowledge.write', context: 'rh', description: "Valider ou écarter une proposition de connaissance" },
  { name: 'rh.push.manage', context: 'rh', description: "Gérer ses propres notifications push" },
  { name: 'rh.register.read', context: 'rh', description: "Consulter le registre du personnel, y compris les données sensibles (RUP)" },
  { name: 'rh.register.write', context: 'rh', description: "Créer et modifier les fiches du personnel, contrats et codes PIN" },
  { name: 'rh.roster.read', context: 'rh', description: "Consulter l'annuaire de l'équipe" },
  { name: 'rh.timesheet.read', context: 'rh', description: "Consulter tous les pointages" },
  { name: 'rh.timesheet.read_open', context: 'rh', description: "Voir qui est actuellement en poste (pointages ouverts)" },
  { name: 'rh.timesheet.write', context: 'rh', description: "Corriger et saisir les pointages" },
];
